export const stats = [
  { label: 'Years Operating', value: '25+ Years Since 1998' },
  { label: 'Bonding Capacity', value: '$5M Single / $10M Aggregate' },
  { label: 'Safety', value: 'OSHA-30 Certified Field Teams' },
  { label: 'Critical Facilities', value: 'Hospitals, Courthouses, Data Centers' },
];
